'use strict'

// Front Dashboard theme loaded separately via front_dashboard_shared bundle
import '../../sass/companies_dash/project.scss'

///////////////////
// StimulusJS
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

window.Stimulus = Application.start()
const context = require.context('./controllers', true, /\.js$/)
Stimulus.load(definitionsFromContext(context))
// /StimulusJS
///////////////////

// Companies Dashboard specific
import './company_settings_form'
